var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronRightSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9.656,
    height: 16.148,
    viewBox: "0 0 9.656 16.148",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "chevron-right-solid",
    d: "M36.894,46.36l-7.081,7.187a.865.865,0,0,1-1.237,0l-.826-.838a.9.9,0,0,1,0-1.254l5.612-5.723-5.612-5.723a.9.9,0,0,1,0-1.254l.826-.838a.865.865,0,0,1,1.237,0L36.894,45.1A.9.9,0,0,1,36.894,46.36Z",
    transform: "translate(-27.494 -37.658)",
    fill: "#146f62"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRightSolid);
export default __webpack_public_path__ + "static/media/chevron-right-solid.46e84a2c38c9c7eb1d108a51392f8db4.svg";
export { ForwardRef as ReactComponent };